import { Controller, useFormContext } from 'react-hook-form';

import FormHelperText from '@mui/material/FormHelperText';

import { IconButton } from '@mui/material';
import Iconify from '../iconify';
import { Upload, UploadAvatar, UploadBox, UploadProps } from '../upload';

// ----------------------------------------------------------------------

interface Props extends Omit<UploadProps, 'file'> {
  name: string;
  multiple?: boolean;
  handleDeleteImage?: () => void;
  handleEditImage?: () => void;
  showEdit?: boolean;
}

// ----------------------------------------------------------------------

export function RHFUploadAvatar({ name, handleDeleteImage, handleEditImage, showEdit, ...other }: Props) {
  const { control } = useFormContext();


  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div style={{ position: 'relative' }}>

          <UploadAvatar error={!!error} file={field.value} {...other} />

          {/* {field.value && showEdit && handleEditImage &&
            <IconButton size="small" onClick={handleEditImage} style={{ position: 'absolute', top: '10%', left: '62.5%' }}>
              <Iconify icon="flowbite:edit-outline" width={20} />
            </IconButton>
          } */}

          {field.value && handleDeleteImage &&
            <IconButton size="small" onClick={handleDeleteImage} disabled={other.disabled} style={{ position: 'absolute', top: '10%', left: '62.5%' }}>
              <Iconify icon="mdi:delete" width={20} />
            </IconButton>
          }


          {!!error && (
            <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}

// ----------------------------------------------------------------------

export function RHFUploadBox({ name, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <UploadBox files={field.value} error={!!error} {...other} />
      )}
    />
  );
}

// ----------------------------------------------------------------------

export function RHFUpload({ name, multiple, helperText, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) =>
        multiple ? (
          <Upload
            // @ts-ignore
            multiple
            accept={{ 'image/*': [] }}
            files={field.value}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{ px: 2 }}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            {...other}
          />
        ) : (
          <Upload
            // @ts-ignore
            accept={{ 'image/*': [] }}
            file={field.value}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{ px: 2 }}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            {...other}
          />
        )
      }
    />
  );
}
